import React from "react";
import { SafeArtistImage } from "./storeArtistFormImage";

const STORE_IMAGE_GETTERS = {
  spotify: data => data?.image_small || data?.image_big || "",
  deezer: data =>
    data?.picture_small ||
    data?.picture_medium ||
    data?.picture_big ||
    data?.image_small ||
    "",
  amazon: data => data?.image_small || data?.image_big || "",
};

/** Resolve artwork URL for a specific store dropdown option. */
export const getStoreOptionImage = (data, store = "spotify") => {
  if (!data) {
    return "";
  }
  const getter = STORE_IMAGE_GETTERS[store] || STORE_IMAGE_GETTERS.spotify;
  return getter(data) || "";
};

const optionImageStyle = {
  borderRadius: "50%",
  objectFit: "cover",
  flexShrink: 0,
};

/** react-select v3: selected value display (menu uses StoreSelectOption). */
export const formatStoreOptionLabel = (data, store = "spotify") => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      minHeight: 32,
    }}
  >
    <SafeArtistImage
      src={getStoreOptionImage(data, store)}
      alt={data.label || data.name || "artist"}
      style={{
        ...optionImageStyle,
        height: 32,
        width: 32,
        marginRight: 8,
      }}
    />
    <span>{data.label}</span>
  </div>
);

export const formatSpotifyOptionLabel = data => formatStoreOptionLabel(data, "spotify");
export const formatDeezerOptionLabel = data => formatStoreOptionLabel(data, "deezer");
export const formatAmazonOptionLabel = data => formatStoreOptionLabel(data, "amazon");

/** react-select v3 Option — innerRef required or menu/search breaks. */
export const createStoreSelectOption = store => {
  const StoreSelectOption = ({ innerRef, innerProps, data, isFocused }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        padding: "8px 12px",
        backgroundColor: isFocused ? "#f5f5f5" : "transparent",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <SafeArtistImage
        src={getStoreOptionImage(data, store)}
        alt={data.label || "artist"}
        style={{
          ...optionImageStyle,
          height: 40,
          width: 40,
          marginRight: 8,
        }}
      />
      <span>{data.label}</span>
    </div>
  );
  return StoreSelectOption;
};

export const SpotifySelectOption = createStoreSelectOption("spotify");
export const DeezerSelectOption = createStoreSelectOption("deezer");
export const AmazonSelectOption = createStoreSelectOption("amazon");
